import debounce from 'debounce';
import select from 'dom-select';

export const AccordionTabs = (el) => {
  const ui = {
    el,
    body: select('body', document),
    details: select.all('.details', el),
    firstDetail: select('.details:first-of-type', el),
    expand: select('.accordion-tabs__expand', el),
    collapse: select('.accordion-tabs__collapse', el),
    wrapper: select('.wrapper', el),
  };

  let threshold = 1024;
  let name = 'tab';

  // The `name` attribute enables multiple <details> elements to be connected, with only one open at a time. This is useful for 'tab' behavior. 
  const addDetailNames = () => {
    ui.details.forEach(detail => {
      detail.setAttribute('name', name);
    });
  }

  const removeDetailNames = () => {
    ui.details.forEach(detail => {
      detail.removeAttribute('name');
    });
  }

  const openAll = () => {
    ui.details.forEach(detail => {
      detail.setAttribute('open', 'open');
    });
  }

  const closeAll = () => {
    ui.details.forEach(detail => {
      detail.removeAttribute('open');
    });
  }

  const setHeights = () => {
    const windowWidth = window.innerWidth;
    // Only proceed if tabs are enabled and window is wide enough
    if (ui.el.dataset.tabs && (windowWidth > threshold)) {
      const openDetail = ui.details.find(detail => detail.open);
      if (openDetail) {
        const summary = select('.summary', openDetail);
        const content = select('.details__content', openDetail);
        if (summary && content) {
          const summaryHeight = summary.getBoundingClientRect().height;
          const contentHeight = content.getBoundingClientRect().height;
          const totalHeight = summaryHeight + contentHeight;
          ui.wrapper.style.height = totalHeight + 'px';
        }
      }
    } else if (ui.wrapper) {
      ui.wrapper.style.height = 'auto';
    }
  }

  const openFirst = () => {
    ui.firstDetail.setAttribute('open', 'open');
  }

  const addNameAttributesToDesktopTabs = () => {
    let windowWidth = window.innerWidth;

    // Executed only if "data-tabs='true'" on the container and on > 834vw 
    if (el.dataset.tabs === 'true') {
      if (windowWidth >= threshold) {
        addDetailNames();

        let openDetails = select.all('.details[open]', el);
        let openDetailsCount = openDetails.length;

        if (openDetailsCount === 0 || openDetailsCount > 1) {
          closeAll();
          openFirst();
        }

      } else {
        removeDetailNames();
      }
    }
  }

  const addEvents = () => {
    addNameAttributesToDesktopTabs();

    window.addEventListener('resize', debounce(() => {
      addNameAttributesToDesktopTabs();
      setHeights();
    }, 200));

    if (ui.expand) {
      ui.expand.addEventListener('click', () => {
        openAll();
      });
    }

    if (ui.collapse) {
      ui.collapse.addEventListener('click', () => {
        closeAll();
      });
    }
  }

  const init = () => {
    addEvents();
    setHeights();
  };

  init();
};

export default AccordionTabs;
